<template>
  <div class="chat-pannel" :class="{openInfo: chatTruth.isSliderShow}">
    <span class="btn-close" @click="handleClose">
      <svg-icon icon-class="close"></svg-icon>
    </span>
    <div class="pannel-left relative fl" :class="{isQuickShow: chatTruth.isQuickShow}">
      <div class="quick-left-chat fl">
        <div class="pannel-left-header">
          <div class="pannel-title">
            <div class="visitor fl">
              <div class="visitor-img fl">
                <span v-if="chatItem.onlineVisitorEntity.visitorHeadimg ? true : false">
                  <img
                    :src="avatarX(chatItem.onlineVisitorEntity.visitorHeadimg)"
                    alt
                    :class="{off: chatItem.onlineVisitorEntity.visitorStatus == 0 ? true : false}"
                  />
                </span>
                <span v-else>访客</span>
              </div>
              <div class="visitor-info fl">
                <div class="nick">
                  <span class="fl">{{ chatItem.visitorinfo.name }}</span>
                </div>
                <div class="tags">
                  <span
                    class="client-status fl"
                  >{{ chatItem.onlineVisitorEntity.visitorStatus | formatLine }}</span>
                </div>
              </div>
                <div class="historyTrack" @click="getHistoryTrack">历史轨迹</div>
                <div
                  class="realTime-view-open"
                  v-if="realtimeViewOpen"
                  @click="changeRealtimeView"
                >打开实时查看记录</div>
                <div
                  class="realTime-view-open"
                  v-if="!realtimeViewOpen"
                  @click="changeRealtimeView"
                >关闭实时查看记录</div>
                </div>
              </div>
          </div>
        <div class="pannel-left-cont">
          <div class="pannel-message">
            <div class="load-more">
              <el-button type="text" @click="chatHistoryClick" v-if="chatItem.isChecked">查看之前的对话</el-button>
              <el-button type="text" icon="el-icon-loading" v-if="chatItem.isLoading">加载中</el-button>
            </div>
            <div class="messages" id="chatContainer" ref="detailCont">
              <div
                class="client-event clearfix"
                v-for="(msg, index) in chatItem.messages"
                :key="index"
                v-if="msg.role == 'event'"
              >
                <span>{{ msg.text }}</span>
                <span>&nbsp;</span>
                <span class="msg-date">
                  <span>{{ msg.sendtime | formatTime }}</span>
                </span>
              </div>
              <div class="msg-agent clearfix" v-else-if="msg.role == 'agent'">
                <div class="time-sender">
                  <span class="time">{{ msg.sendtime | formatTime }}</span>
                  <span style="padding-left: 5px;">{{ msg.agent_nickname}}</span>
                </div>
                <div class="j-user">
                  <span class="agent-name none" v-if="avatarX(msg.agent_avatar) ? true : false">
                    <img
                      :src="avatarX(msg.agent_avatar)"
                      alt
                      :class="{off: chatItem.onlineVisitorEntity.visitorStatus == 0 ? true : false}"
                    />
                  </span>
                  <span class="agent-name" v-else>{{ msg.role | formatRole }}</span>
                </div>
                <div class="bubble">
                  <div
                    class="text"
                    v-if="msg.msg_type == 'text'"
                    v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"
                  ></div>
                  <div class="text" v-else-if="msg.msg_type == 'image'">
                    <img :src="msg.text" class="upload-img" preview="3" />
                  </div>
                  <div class="text" v-else-if="msg.msg_type == 'file'">
                    <i class="el-icon-document"></i>
                    <span>{{ msg.text.split(',')[0] }}</span>
                    <a :href="msg.text.split(',')[1]" target="_blank">下载文件</a>
                  </div>
                  <div
                    class="goodsLink"
                    v-else-if="msg.msg_type == 'goods'"
                    @click="goodsLinkerHandler(JSON.parse(msg.text).link)"
                  >
                    <div class="goodsMain">
                      <div class="goodsLef">
                        <span>
                          <img :src="JSON.parse(msg.text).img" alt />
                        </span>
                      </div>
                      <div class="goodsRig">
                        <h3>{{ JSON.parse(msg.text).title }}</h3>
                        <p>
                          <em>￥</em>
                          {{ JSON.parse(msg.text).price }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="voice text clearfix"
                    @click="voicePlay($event)"
                    v-else-if="msg.msg_type == 'voice'"
                  >
                    <div class="play_voice clearfix" data-time="46">
                      <span>{{msg.talk_time}}</span>''
                      <audio
                        class="audioId"
                        preload="auto"
                        hidden="true"
                        :index="index"
                        ref="audio"
                      >
                        <source :src="msg.text" type="audio/mpeg" />
                      </audio>
                      <div class="wifi-symbol voice-agent">
                        <div class="wifi-circle first"></div>
                        <div class="wifi-circle second" ref="second"></div>
                        <div class="wifi-circle third" ref="third"></div>
                      </div>
                    </div>
                  </div>
                  <div class="video_css" v-else-if="msg.msg_type == 'video'">
                    <video class="videoId" preload
                            controls
                            controlslist="nodownload"
                    @click="videoStop($event)">
                      <source :src="msg.text" type="video/mp4" />
                      <!--<source src="http://weiliao.oss.aliyuncs.com/audio/1551081961/6fdb3f461f5a41ec8d55b746f6f27198-VID20190225160556.mp4" type="video/mp4" />-->
                    </video>
                    <div class="video_mask">
                      <svg-icon
                        class="video_play_icon"
                        @click.native="videoPlay($event)"
                        icon-class="video_play"
                      ></svg-icon>
                    </div>
                  </div>
                  <div class="goodsLink" v-else-if="msg.msg_type == 'coupon'">
                    <div class="goodsMain">
                      <div class="goodsLef">
                        <span>
                          <img class="couponImg" src="@/assets/images/couponImg.png" alt />
                        </span>
                      </div>
                      <div class="goodsRig coupon">
                        <h3>{{ JSON.parse(msg.text).title }}</h3>
                        <p
                          class="time"
                        >{{ JSON.parse(msg.text).start_time | formatCouponTime }} 至 {{ JSON.parse(msg.text).end_time | formatCouponTime }}</p>
                        <p>
                          <span class="red">
                            <em>￥</em>
                            {{ JSON.parse(msg.text).price }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="goodsLink" v-else-if="msg.msg_type == 'express'">
                    <div class="title">
                      <p class="fl">订单编号{{ JSON.parse(msg.text).order_no }}</p>
                      <p
                        class="fr"
                        :class="{'red': JSON.parse(msg.text).status != 4}"
                        v-if="chatItem.visitorinfo.source_qk == 'wfx'"
                      >{{ formatOrderStatus(JSON.parse(msg.text).status) }}</p>
                      <p
                        class="fr red"
                        v-if="chatItem.visitorinfo.source_qk == 'wxapp'"
                      >{{ WXAPPFormatOrderStatus(JSON.parse(msg.text).status) }}</p>
                    </div>
                    <div class="goodsMain">
                      <div class="goodsLef">
                        <span>
                          <img :src="JSON.parse(msg.text).img" alt />
                        </span>
                      </div>
                      <div class="goodsRig">
                        <h3>{{ JSON.parse(msg.text).title }}</h3>
                        <p>
                          <em>￥</em>
                          {{ JSON.parse(msg.text).price }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="placeOrderMsg" v-if="msg.msg_type === 'place_order'">
                    <div v-if="JSON.parse(msg.text).status == 0" class="orderTitle">亲，您有一笔订单未付款~</div>
                    <div v-else class="orderTitle">核对订单信息</div>
                    <a
                      :href="JSON.parse(msg.text).goodsUrl"
                      target="_blank"
                      class="orderGood-container"
                    >
                      <div class="goods-image">
                        <img :src="JSON.parse(msg.text).image" alt />
                      </div>
                      <div class="goods-detail">
                        <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                        <div
                          class="goods-order-detail"
                        >共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                      </div>
                    </a>
                    <div class="addressInfo" v-if="JSON.parse(msg.text).status != 0">
                      <span class="label">地址：</span>
                      <span class="detail">{{JSON.parse(msg.text).receiverAddress}}</span>
                    </div>
                  </div>
                  <div class="arrivalMsg" v-if="msg.msg_type === 'arrival_notice'">
                    <div class="orderTitle">验收提醒</div>
                    <a
                      :href="JSON.parse(msg.text).goodsUrl"
                      target="_blank"
                      class="orderGood-container"
                    >
                      <div class="goods-image">
                        <img :src="JSON.parse(msg.text).image" alt />
                      </div>
                      <div class="goods-detail">
                        <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                        <div
                          class="goods-order-detail"
                        >共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                      </div>
                    </a>
                    <div class="deliveryTips">{{JSON.parse(msg.text).acceptanceMsg}}</div>
                  </div>
                  <div class="deliveryMsg" v-if="msg.msg_type === 'delivery_notice'">
                    <div class="orderTitle">订单已发货</div>
                    <a
                      :href="JSON.parse(msg.text).goodsUrl"
                      target="_blank"
                      class="orderGood-container"
                    >
                      <div class="goods-image">
                        <img :src="JSON.parse(msg.text).image" alt />
                      </div>
                      <div class="goods-detail">
                        <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                        <div
                          class="goods-order-detail"
                        >共计{{JSON.parse(msg.text).goodsNum}}件商品，合计￥{{JSON.parse(msg.text).payment}}</div>
                      </div>
                    </a>
                    <div
                      class="deliveryInfo"
                      v-if="showMore"
                      v-for="(item, i) in JSON.parse(msg.text).logistics"
                      :key="i"
                    >
                      <div class="deliveryInfo-item">
                        <div class="deliveryInfo-label">物流公司：</div>
                        <div class="deliveryInfo-detail">{{item.express}}</div>
                      </div>
                      <div class="deliveryInfo-item">
                        <div class="deliveryInfo-label">快递单号：</div>
                        <div class="deliveryInfo-detail">{{item.expressNo}}</div>
                      </div>
                    </div>
                    <div class="deliveryInfo" v-if="JSON.parse(msg.text).logistics[0] && !showMore">
                      <div class="deliveryInfo-item">
                        <div class="deliveryInfo-label">物流公司：</div>
                        <div
                          class="deliveryInfo-detail"
                        >{{JSON.parse(msg.text).logistics[0].express}}</div>
                      </div>
                      <div class="deliveryInfo-item">
                        <div class="deliveryInfo-label">快递单号：</div>
                        <div
                          class="deliveryInfo-detail"
                        >{{JSON.parse(msg.text).logistics[0].expressNo}}</div>
                      </div>
                    </div>
                    <div
                      style="text-align: center;cursor:pointer;font-size: 18px;padding-top: 3px;color: #ccc;"
                      v-if="JSON.parse(msg.text).logistics.length > 1 && !showMore"
                    >
                      <i @click="showMore = true" class="el-icon-arrow-down"></i>
                    </div>
                  </div>
                  <div class="refundMsg" v-if="msg.msg_type === 'refund_notice'">
                    <div class="orderTitle">退/换货申请已通过审核</div>
                    <div class="order-msg-no">订单编号：{{JSON.parse(msg.text).orderNo}}</div>
                    <a :href="JSON.parse(msg.text).goodsUrl" class="orderGood-container">
                      <div class="goods-image">
                        <img :src="JSON.parse(msg.text).image" alt />
                      </div>
                      <div class="goods-detail">
                        <div class="goods-order-title">{{JSON.parse(msg.text).title}}</div>
                      </div>
                    </a>
                    <div class="refundInfo">
                      <p>共计 {{JSON.parse(msg.text).goodsNum}} 件商品</p>
                      <p>实际退款：￥{{JSON.parse(msg.text).payment}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="msg-client clearfix" v-else-if="msg.role == 'client'">
                <div class="time-sender">
                  <span class="time">{{ msg.sendtime | formatTime }}</span>
                </div>
                <div class="j-user">
                  <span
                    class="agent-name none"
                    v-if="chatItem.onlineVisitorEntity.visitorHeadimg ? true : false"
                  >
                    <img
                      :src="avatarX(chatItem.onlineVisitorEntity.visitorHeadimg)"
                      alt
                      :class="{off: chatItem.onlineVisitorEntity.visitorStatus == 0 ? true : false}"
                    />
                  </span>
                  <span class="agent-name" v-else>{{ msg.role | formatRole }}</span>
                </div>
                <div class="bubble">
                  <div
                    class="text"
                    v-if="msg.msg_type == 'text'"
                    v-html="$utils.renderUrl(formatTrendEmoji(msg.text))"
                  ></div>
                  <div class="text" v-else-if="msg.msg_type == 'image'">
                    <img :src="msg.text" class="upload-img" preview="3" />
                  </div>
                  <div class="text" v-else-if="msg.msg_type == 'file'">
                    <i class="el-icon-document"></i>
                    <span>{{ msg.text.split(',')[0] }}</span>
                    <a :href="msg.text.split(',')[1]" target="_blank">下载文件</a>
                  </div>
                  <div v-else-if="msg.msg_type == 'goods'">
                    <div
                      class="goodsLink"
                      v-if="chatItem.visitorinfo.source_qk == 'wxapp'"
                      @click="goodsWxappHandler"
                    >
                      <div class="goodsMain">
                        <div class="goodsLef">
                          <div class="wxapp-img" v-html="formatWechatImg(JSON.parse(msg.text).img)"></div>
                          <!--                                                                                                        <span>-->
                          <!--                                                                                                            <img :src="JSON.parse(msg.text).img" alt="">-->
                          <!--                                                                                                        </span>-->
                        </div>
                        <div class="goodsRig">
                          <h3>{{ JSON.parse(msg.text).title }}</h3>
                          <!-- <p><em>￥</em>{{ JSON.parse(msg.text).price }}</p> -->
                        </div>
                      </div>
                    </div>
                    <div
                      class="goodsLink"
                      v-else
                      @click="goodsLinkerHandler(JSON.parse(msg.text).link)"
                    >
                      <div class="goodsMain">
                        <div class="goodsLef">
                          <span>
                            <img :src="JSON.parse(msg.text).img" alt />
                          </span>
                        </div>
                        <div class="goodsRig">
                          <h3>{{ JSON.parse(msg.text).title }}</h3>
                          <p>
                            <em>￥</em>
                            {{ JSON.parse(msg.text).price }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="voice text clearfix"
                    @click="voicePlay($event)"
                    v-else-if="msg.msg_type == 'voice'"
                  >
                    <div class="play_voice clearfix" data-time="46">
                      <span>{{msg.talk_time}}</span>''
                      <audio
                        class="audioId"
                        preload="auto"
                        hidden="true"
                        :index="index"
                        ref="audio"
                      >
                        <source :src="msg.text" type="audio/mpeg" />
                      </audio>
                      <div class="wifi-symbol voice-client">
                        <div class="wifi-circle first"></div>
                        <div class="wifi-circle second" ref="second"></div>
                        <div class="wifi-circle third" ref="third"></div>
                      </div>
                    </div>
                  </div>
                  <div class="video_css" v-else-if="msg.msg_type == 'video'">
                    <video class="videoId" preload
                            controls
                            controlslist="nodownload"
                            @click="videoStop($event)">
                      <source :src="msg.text" type="video/mp4" />
                      <!--<source src="http://weiliao.oss.aliyuncs.com/audio/1551081961/6fdb3f461f5a41ec8d55b746f6f27198-VID20190225160556.mp4" type="video/mp4" />-->
                    </video>
                    <div class="video_mask">
                      <svg-icon
                        class="video_play_icon"
                        @click.native="videoPlay($event)"
                        icon-class="video_play"
                      ></svg-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pannel-edit" :class="{editFocus: chatTruth.isTextArea}">
            <div class="edit-header relative">
              <div class="chat-bar-container">
                <el-tooltip class="item" effect="dark" content="表情" placement="bottom-start">
                  <el-button @click.prevent.stop="clickEmoji">
                    <svg-icon class="chat-bar-icon" icon-class="emoji-icon"></svg-icon>
                  </el-button>
                </el-tooltip>

                <el-tooltip
                  class="item sendImgItem"
                  effect="dark"
                  content="发送图片"
                  placement="bottom-start"
                  v-if="userAuth.is_upload"
                >
                  <el-button @click.native="btnUploadImgHandler">
                    <svg-icon class="chat-bar-icon" icon-class="image"></svg-icon>
                  </el-button>
                </el-tooltip>
                <el-tooltip
                  class="item sendImgItem"
                  effect="dark"
                  content="发送文件"
                  placement="bottom-start"
                  v-if="userAuth.is_upload"
                >
                  <el-button @click.native="btnUploadFileHandler">
                    <svg-icon class="chat-bar-icon" icon-class="folder"></svg-icon>
                  </el-button>
                </el-tooltip>
                <el-tooltip
                  class="item sendImgItem"
                  effect="dark"
                  content="发送视频"
                  placement="bottom-start"
                  v-if="false"
                >
                  <el-button @click.native="btnUploadVideoHandler">
                    <svg-icon class="chat-bar-icon" icon-class="video"></svg-icon>
                  </el-button>
                </el-tooltip>

                <!--                                <el-button class="quick-reply" @click="quickReceiveClickHandler"-->
                <!--                                           v-if="userAuth.is_quick_reply">快捷回复-->
                <!--                                </el-button>-->
              </div>
              <vue-emoji
                @selectedEmoji="selectEmoji"
                @click.native="TplClickEmoji($event)"
                v-show="chatTruth.showEmoji"
              ></vue-emoji>
              <input
                id="uploadImgIpt"
                ref="uploadImgIpt"
                type="file"
                @change="ImgSendClickHandler"
                hidden
              />
              <input
                id="uploadFileIpt"
                type="file"
                ref="uploadFileIpt"
                @change="FileSendClickHandler"
                hidden
              />
              <input
                id="uploadVideoIpt"
                type="file"
                ref="uploadVideoIpt"
                @change="videoSendClickHandler"
                hidden
              />
            </div>
            <div class="edit-middle">
              <div
                contenteditable="true"
                @focus="insertDIVFnFocus"
                @blur="insertDIVFnBlur"
                @keydown="textareaKeyDown"
                id="chatTextDiv"
                style="height: 100%;overflow-y: scroll;outline: none;padding: 8px;box-sizing: border-box;font-size: 13px;"
              ></div>
              <el-input
                style="display: none;"
                id="chatTextArea"
                type="textarea"
                :rows="5"
                @keyup.native="textareaKeyUp"
                @keydown.native="textareaKeyDown"
                @focus="textareaOnFocus"
                @blur="textareaOnBlur"
                placeholder="请输入内容"
                v-model="chatInit.textarea"
              ></el-input>
            </div>
            <div class="edit-footer">
              <el-button type="text">Enter 发送，Ctrl+Enter 换行</el-button>
              <el-button
                size="small"
                :disabled="chatTruth.sendBtn"
                @click.native.prevent="sendMessageBtn"
              >发送</el-button>
            </div>
          </div>
        </div>
      </div>
      <span class="btn-open" @click="sliderShowHandler"></span>
    </div>
    <div class="pannel-right relative fr">
      <div class="chat-user-tab">
        <!-- <el-tabs v-model="chatInit.activeName">
                  <el-tab-pane label="商品" name="goods">
                    <ChatGoodsInfo :goodsinfo="chatItem.apiInfo.goodsinfo.data" v-if="chatItem.apiInfo.goodsinfo"></ChatGoodsInfo>
                    <div class="tab-noData" v-else>
                      <p>暂无商品数据</p>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="订单" name="order">
                    <ChatOrderInfo :orderinfo="chatItem.apiInfo.orderinfo.data" v-if="chatItem.apiInfo.orderinfo"></ChatOrderInfo>
                    <div class="tab-noData" v-else>
                      <p>暂无订单数据</p>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="会员" name="user">
                    <ChatUserInfo :userinfo="chatItem.apiInfo.userinfo.data" v-if="chatItem.apiInfo.userinfo"></ChatUserInfo>
                    <div class="tab-noData" v-else>
                      <p>暂无会员数据</p>
                    </div>
                  </el-tab-pane>
        </el-tabs>-->
        <div class="tab-components">
          <!-- <ChatVisitInfo :visitinfo="chatItem.visitinfo" v-if="chatInit.root.is_track"></ChatVisitInfo> -->
          <ChatVisitorInfo
            :visitorinfo="chatItem.visitorinfo"
            :visitorId="chatItem.onlineVisitorEntity.visitorId"
			@refreshVisitorInfo="refreshVisitorInfo"
          ></ChatVisitorInfo>
		  <ChatTags :tags="chatItem.tags" :visitorId="chatItem.onlineVisitorEntity.visitorId" @chatTags="tagsHandler"></ChatTags>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialogCheckImg"
      title="图片预览"
      :visible.sync="chatTruth.dialogImgVisible"
      width="43%"
    >
      <img :src="chatTruth.dialogImgVisibleUrl" />
    </el-dialog>

    <!--    历史轨迹弹窗-->
    <el-dialog
            title="历史轨迹"
            class="history-track-dialog"
            :visible.sync="historyTrackDialogVisible"
            width="70%"
            style="background: rgba(0, 0, 0, 0.3)"
			:modal="false"
    >
      <ul
              class="history-track-container"
              v-if="historyTrackList.length > 0"
              @scroll="loadMoreHistoryTrack"
              ref="historyTrackContainer"
      >
        <li class="history-track-item" v-for="(item, index) in historyTrackList" :key="index">
          <div class="history-track-time">
            <div>{{$utils.timestampToTime(item.createTime).split(' ')[0]}}</div>
            <div>{{$utils.timestampToTime(item.createTime).split(' ')[1]}}</div>
          </div>
          <div class="history-track-content" v-if="item.isSearchEngins == 0">
            从【{{item.trackTitle}}
            <span v-if="item.trackKeyword.trim().length > 0">，搜索关键词：{{item.trackKeyword}}</span>】
            <a :href="item.trackUrl" target="_blank">{{item.trackUrl}}</a>进入，停留
            <span>{{item.trackTime}}</span>秒
          </div>
          <div class="history-track-content" v-else>
            从【搜索引擎
            <span v-if="item.trackKeyword.trim().length > 0">，搜索关键词：{{item.trackKeyword}}</span>】:
            <a :href="item.trackUrl" target="_blank"
            >{{ item.trackSearchEnginsUrl.split('/')[0] + '//'+item.trackSearchEnginsUrl.split('/')[2] }}</a>进入:
            <a href>{{item.trackUrl}}</a>
          </div>
        </li>
      </ul>
      <div v-else style="text-align: center;font-size: 13px;">暂无历史轨迹数据</div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import Store from "@/utils/store";
import avatar0 from "@/assets/images/client_avatar_empty.png";
import avatar1 from "@/assets/images/client_avatar1.png";
import avatar2 from "@/assets/images/client_avatar2.png";
import avatar3 from "@/assets/images/client_avatar3.png";
import avatar4 from "@/assets/images/client_avatar4.png";
import avatar5 from "@/assets/images/client_avatar5.png";
import avatar6 from "@/assets/images/client_avatar6.png";
import avatar7 from "@/assets/images/client_avatar7.png";

import emojiData from "@/libs/emoji/emoji-data";
import VueEmoji from "@/libs/emoji/Emoji";
import ChatVisitorInfo from "./ChatVisitorInfo";
import ChatTags from "./ChatTags";
import Cookies from 'js-cookie'
export default {
  props: ["historyData"],
  data() {
    return {
      showMore: false,
      isFocus: true,
      newMsgId: "",
      realtimeViewOpen: true,
      oldChatHeight: 0,
      chatItem: "",
      chatTruth: {
        isDefault: true, //【对话界面第一次加载时】如果对话中没有访客，则不显示，该值为false；如果有访客，则显示，该值为true
        goods: false, //【是否有商品数据】
        order: false, //【是否有订单数据】
        user: false, //【是否有会员数据】
        showEmoji: false, //【emoji显示/隐藏】默认隐藏
        sendBtn: true, //【发送消息按钮】默认disabled
        isQuickShow: false, //【显示/隐藏快捷回复样式】
        isChecked: false, //【点击加载更多】默认显示
        isLoading: false, //【是否加载中】默认隐藏
        isSliderShow: false, //【对话框右侧内容】默认展开
        dialogImgVisible: false, //【显示dialog】
        dialogImgVisibleUrl: "", //【显示聊天图片】
        isShow: true, //【是否显示面板】默认显示
        isTextArea: false //textarea获取焦点时背景白色，失去焦点时背景灰色
      },
      chatInit: {
        agentAvatar: "", //【客服头像】
        agentId: "", //【客服id】
        agentName: "", //【客服名称】
        token: "", //【token】
        tagName: "tc-", //【表情分类】
        textarea: "",
        pageNum: 1, //【加载更多数据页数】
        pageSize: 0, //【加载数据条数】
        scrollHeight: 0, //【查询更多数据高度】
        activeName: "goods" //【右侧tab默认选中】
      },
      ticketData:{
         currentPage: 1, //【当前页数】
          pageSize: null, //【返回条数】
          num: 0, //在线访客数量
          visitorId: Store.fetch("chat-onlineVisitorId") != "" ?
            Store.fetch("chat-onlineVisitorId") : "", //【选中对话访客Id】
          initChat: false, //【初始化对话列表】
          initData: [], //【初始化对话数据】
          data: {} //【选中访客相关数据】
      },
      /**
       * 【个人信息修改参数】
       * 访客id
       * 访客信息属性名称
       * 访客信息属性值
       */
      postData: {
        visitorId: "",
        name: "",
        value: ""
      },
      /**
       * 获取访客头像，目前是直接引入项目图片文件夹中的图片
       * 没有使用绝对地址，后期如果更换为阿里云地址，该数据可不需要
       */
      avatarIMG: {
        //访客头像
        avatar0: avatar0,
        avatar1: avatar1,
        avatar2: avatar2,
        avatar3: avatar3,
        avatar4: avatar4,
        avatar5: avatar5,
        avatar6: avatar6,
        avatar7: avatar7
      },
      Emoji: {
        data: [
          "smile",
          "wink",
          "angry",
          "blush",
          "cold_sweat",
          "flushed",
          "grin",
          "heart_eyes",
          "joy",
          "kissing_ce",
          "kissing_se",
          "laughing",
          "mask",
          "ok_hand",
          "scream",
          "sleeping",
          "smirk",
          "sob",
          "sunglasses",
          "sweat_smile",
          "tongue",
          "thumbsup",
          "clap"
        ]
      },
      loadDataTimer: null, //每隔500ms刷新一次-定时器
      loadDataTime: 5000, //每隔500ms刷新一次
      imgAccept: "image/gif, image/jpeg, image/png, image/jpg",
      fileAccept:
        "text/plain,text/cvs,application/zip, application/octet-stream, application/vnd.ms-excel, application/msword, application/x-zip-compressed, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, type= application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      videoAccept: "video/mp4",
      historyTrackDialogVisible: false,
      historyTrackList: [],
      historyTrackPageSize: 10,
      historyTrackPageNum: 1,
      historyTrackLoadMore: false,
      externalLinkList: [], // 白名单(防外链)列表
      canDownLoadData: true,
      showPop:true
    };
  },
  components: {
    VueEmoji,
    ChatVisitorInfo,
	ChatTags
  },
  watch: {
    /**
     * 动态添加数据滚动条自动滚动到底部
     */
    "chatItem.messages"() {
      this.$nextTick(() => {
        let chatList = document.getElementById("chatContainer");
        if (chatList) {
          chatList.scrollTop = chatList.scrollHeight - this.oldChatHeight;
          chatList.addEventListener("scroll", this.scrollListener, false);
        }
      });
    },
    "ticketData.visitorId": {
      //选中对话中的访客的索引
      handler: function(val,oldVal) {
        Store.save("chat-onlineVisitorId", this.chatItem.visitorId);
      },
      deep: true
    },

    historyData() {
      this.chatItem = this.historyData;
    }
  },
  computed: {
    userData() {
      return this.$store.state.user;
    },
    userAuth() {
      return this.$store.state.user.isAuth;
    }
  },
  filters: {
    /**
     * 局部过滤器
     */
    formatLine: value => {
      //当前选中访客状态格式化
      switch (value) {
        case 1:
          return "在线";
          break;
        case 0:
          return "离线";
          break;
      }
    },
    formatRole: value => {
      //当前选中访客角色格式化
      switch (value) {
        case "agent":
          return "客服";
          break;
        case "client":
          return "访客";
          break;
      }
    },
    /**
     * 【聊天纪录时间】
     * */
    formatTime: value => {
      const time_month = new Date(value).getMonth() + 1;
      const time_date = new Date(value).getDate();
      const time_lef = time_month + "月" + time_date + "日";
      const time_rig = value.split(" ")[1].substring(0, 5);
      const time = time_lef + " " + time_rig;
      return time;
    },
    formatCouponTime: time => {
      let newTime = new Date(time * 1000),
        year = newTime.getFullYear(),
        month =
          newTime.getMonth() + 1 < 10
            ? "0" + (newTime.getMonth() + 1)
            : newTime.getMonth() + 1,
        date = newTime.getDate();
      return year + "." + month + "." + date;
    }
  },
  updated(){
    let video = document.getElementsByClassName("videoId")
    if(video){
      // 隐藏video标签控制条右侧三个点
      for(let i = 0; i < video.length;i++){
            video[i]['disablePictureInPicture'] = true; //disablePictureInPicture的属性改为true
      }
    }
  },
  methods: {
    getHistoryTrack(){
      this.historyTrackDialogVisible = true
      this.$http.getHistoryTrackAPI({
        visitorId: this.chatItem.onlineVisitorEntity.visitorId,
        pageSize: this.historyTrackPageSize,
        pageNum: this.historyTrackPageNum
      }).then(res => {
        if (res.status == 1) {
          this.historyTrackList = this.historyTrackList.concat(
                  res.data.list
          );
          if (res.data.list.length < this.historyTrackPageSize) {
            this.historyTrackLoadMore = false;
          } else {
            this.historyTrackLoadMore = true;
          }
        }
      })
    },
    // 历史轨迹加在更多
    loadMoreHistoryTrack(){
      let scrollDiv = this.$refs.historyTrackContainer;
      let sh = scrollDiv.scrollHeight;
      let st = scrollDiv.scrollTop;
      let ch = scrollDiv.clientHeight;
      let diff = sh - ch - st;
      if (diff < 30 && this.historyTrackLoadMore) {
        this.historyTrackLoadMore = false;
        this.historyTrackPageNum++;
        this.getHistoryTrack();
      }
    },
    WXAPPFormatOrderStatus(status) {
      switch (status) {
        case "0":
          return "待付款";
          break;
        case "1":
          return "已付款";
          break;
        case "2":
          return "已接单";
          break;
        case "3":
          return "已发货";
          break;
        case "4":
          return "已提货";
          break;
        case "5":
          return "买家已取消";
          break;
        case "6":
          return "过期未付款自动关闭";
          break;
        case "7":
          return "已拒单";
          break;
        case "8":
          return "退款中";
          break;
        case "9":
          return "已退款";
          break;
        case "10":
          return "已部分退款";
          break;
        case "11":
          return "已完成";
          break;
      }
    },
    formatOrderStatus(status) {
      switch (status) {
        case "0":
          return "待付款";
          break;
        case "1":
          return "待发货";
          break;
        case "2":
          return "待收货";
          break;
        case "3":
          return "交易完成";
          break;
        case "4":
          return "订单关闭";
          break;
        case "5":
          return "卖家同意退/换货";
          break;
        case "6":
          return "退/换货中";
          break;
      }
    },
    /**
     * <vue-emoji></vue-emoji>
     * @/libs/emoji
     * @/components/emoji/Emoji
     * 选中emoji
     */
    selectEmoji(emoji) {
      document.getElementById("chatTextDiv").focus();
      this.$nextTick(() => {
        const newEmoji = "[" + emoji.value[0] + "]";
        this.chatTruth.showEmoji = false;
        this.chatTruth.sendBtn = false;
        this.insertHtmlAtCaret(newEmoji);
        // document.getElementById('chatTextDiv').append(newEmoji)
        // document.getElementById('chatTextDiv').focus()
      });
    },
    /**
     * Author: brand
     * Creation Time: 2019-05-07 09:10
     * Description: 光标处插入消息
     */
    insertHtmlAtCaret(html) {
      var sel, range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();
          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    },
    TplClickEmoji(event) {
      event.stopPropagation();
    },
    /**
     * 发送表情
     */
    clickEmoji() {
      this.chatTruth.showEmoji = !this.chatTruth.showEmoji;
      document.getElementById("chatTextDiv").focus();
    },

    /**
     * 文本域输入内容时按钮变成可点击状态，否则变成不可点击
     */
    textareaKeyUp(e) {
      if (this.chatInit.textarea) {
        this.chatTruth.sendBtn = false;
      } else {
        this.chatTruth.sendBtn = true;
      }
    },
    /**
     * Ctrl+Enter 换行
     */
    textareaKeyDown(e) {
      if (e.keyCode == 13 && e.ctrlKey) {
        document.getElementById("chatTextDiv").innerHTML += "<br />";
        this.chatInit.textarea += "\n";
      } else if (e.keyCode == 13) {
        e.preventDefault();
        if (this.chatInit.textarea) {
          this.sendMessageBtn();
        } else {
          Message({
            showClose: true,
            message: "请输入内容",
            type: "error",
            duration: 3 * 1000
          });
        }
      }
    },
    keepInLast() {
      var obj = document.getElementById("chatTextDiv");
      if (window.getSelection) {
        //ie11 10 9 ff safari
        obj.focus(); //解决ff不获取焦点无法定位问题
        var range = window.getSelection(); //创建range
        range.selectAllChildren(obj); //range 选择obj下所有子内容
        range.collapseToEnd(); //光标移至最后
      } else if (document.selection) {
        //ie10 9 8 7 6 5
        var range = document.selection.createRange(); //创建选择对象
        //var range = document.body.createTextRange();
        range.moveToElementText(obj); //range定位到obj
        range.collapse(false); //光标移至最后
        range.select();
      }
    },
    pasteImgFn() {
      let that = this;
      document.querySelector("#chatTextDiv").addEventListener(
        "paste",
        function(e) {
          var cbd = e.clipboardData;
          var ua = window.navigator.userAgent;
          // 如果是 Safari 直接 return
          if (!(e.clipboardData && e.clipboardData.items)) {
            return;
          }
          // Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉
          if (
            cbd.items &&
            cbd.items.length === 2 &&
            cbd.items[0].kind === "string" &&
            cbd.items[1].kind === "file" &&
            cbd.types &&
            cbd.types.length === 2 &&
            cbd.types[0] === "text/plain" &&
            cbd.types[1] === "Files" &&
            ua.match(/Macintosh/i) &&
            Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
          ) {
            return;
          }
          for (var i = 0; i < cbd.items.length; i++) {
            var item = cbd.items[0]; // cbd.items[i]
            if (item.kind == "file") {
              var blob = item.getAsFile();
              if (blob.size === 0) {
                return;
              }
              // blob 就是从剪切板获得的文件 可以进行上传或其他操作
              /*-----------------------与后台进行交互 start-----------------------*/
              let formdata = new FormData();
              formdata.append("file", blob);
              that.$http.uploadImageAPI(formdata).then(res => {
                const resData = res;
                if (resData.status == 1) {
                  var img = document.createElement("img");
                  img.src = resData.data;
                  img.setAttribute("preview", "1"); // 图片预览
                  document.getElementById("chatTextDiv").appendChild(img);
                  that.keepInLast();
                } else {
                  that.$message({
                    showClose: true,
                    message: resData.data,
                    type: "error",
                    duration: 3 * 1000
                  });
                }
              });
              /*-----------------------与后台进行交互 end-----------------------*/
              /*-----------------------不与后台进行交互 直接预览start-----------------------*/
              // var reader = new FileReader();
              // var imgs = new Image();
              // imgs.file = blob;
              // reader.onload = (function(aImg) {
              //   return function(e) {
              //     aImg.src = e.target.result;
              //   };
              // })(imgs);
              // reader.readAsDataURL(blob);
              // imgs.setAttribute('preview','1') // 图片预览
              // document.getElementById('chatTextDiv').appendChild(imgs);
              //that.chatInit.textarea = imgs
              //document.querySelector('#chatTextArea').appendChild(imgs);
              /*-----------------------不与后台进行交互 直接预览end-----------------------*/
            }
          }
        },
        false
      );
    },
    insertDIVFnFocus() {
      var divId = document.getElementById("chatTextDiv");
      if (this.isFocus) {
        this.isFocus = false;
        this.pasteImgFn();
      }

      var that = this;
      divId.addEventListener("DOMSubtreeModified", function() {
        if (divId.innerHTML.trim().length > 0) {
          that.chatTruth.isTextArea = true;
          that.chatTruth.sendBtn = false;
        } else {
          that.chatTruth.sendBtn = true;

          that.chatTruth.isTextArea = false;
        }
        that.chatInit.textarea = divId.innerHTML;
        // that.keepInLast()
      });
    },
    insertDIVFnBlur() {
      // this.chatTruth.sendBtn = true
      // this.chatTruth.isTextArea = true
    },
    textareaOnFocus(e) {
      this.chatTruth.isTextArea = true;
    },
    textareaOnBlur(e) {
      this.chatTruth.isTextArea = false;
    },

    sendMessageBtn() {
	  let reg = /&nbsp;/g;
	  let textArea = this.chatInit.textarea.replace(reg, "").trim()
	  let canSend = true
	  if (this.externalLinkList.length) {
	    this.externalLinkList.forEach(item => {
	      if (textArea.indexOf(item.externalLink) > -1) {
	        this.$message.error('请勿发送包含外链的文本信息')
	        canSend = false
	      }
	    })
	  }
	  if (textArea.length > 5000) {
      this.$message.error('发送内容过长，请清除内容格式或精简内容！')
      canSend = false
    }
	  if (!canSend) {
	    return false
	  }
      if (this.chatInit.textarea.replace(/[ ]|[&nbsp;]/g, "") == "") {
        Message({
          showClose: true,
          message: "发送的内容不能为空",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let postText = this.chatInit.textarea;
      let partten = /\[(.+?)\]/g;
      if (this.chatInit.textarea.match(partten)) {
        this.chatInit.textarea.match(partten).map(item => {
          for (let key in emojiData) {
            let emojiCN = "[" + emojiData[key][0] + "]";
            let emojiEN = ":" + key + ":";
            let reg = new RegExp("\\[(" + emojiData[key][0] + ")\\]", "ig");
            if (item == emojiCN) {
              postText = postText.replace(new RegExp(reg, "g"), emojiEN);
            }
          }
        });
      }
      this.chatTruth.showEmoji = false;
      let tmp_data = {
        type: "say",
        sendtime: this.getTimes(),
        agent_avatar: this.chatInit.agentAvatar,
        sendname: this.chatInit.agentName,
        agent_nickname: this.chatInit.agentName,
        from_uid: this.chatInit.agentId,
        to_uid: this.chatItem.onlineVisitorEntity.visitorId,
        role: "agent",
        msg_type: "text",
        text: postText
      };
      const postData = {
        messagesId: this.chatItem.messageId,
        visitorId: this.chatItem.onlineVisitorEntity.visitorId,
        msgType: "text",
        talk_time: "0",
        // callingNo: this.chatItem.callingNo,
        text: postText
      };
      this.$http.getReplyHandler(postData).then(res => {
        const resData = res;
        if (resData.status == 1) {
          this.newMsgId = res.callingId;
          tmp_data.callingId = res.callingId;
          this.sendTalkData(tmp_data);
          document.getElementById("chatTextArea").focus();
          this.chatInit.textarea = "";
          this.chatTruth.sendBtn = true;
        }
      });
      document.getElementById("chatTextDiv").focus();
      this.chatInit.textarea = "";
      document.getElementById("chatTextDiv").innerHTML = "";
      this.chatTruth.sendBtn = true;
    },
    /**
     * 发送聊天数据，面向对话中的访客
     * 获取当前选中访客id
     * 将发送消息数据添加到当前选中访客的messages字段中
     */
    sendTalkData(data) {
      this.$nextTick(() => {
        this.scrollToChatBottom();
      });
      this.chatItem.messages.push(data);
      // this.ticketData.initData.forEach((item, index) => {
      //   if (item.messages_id == this.chatItem.messages_id) {
      //     item.messages.push(data)
      //   }
      // })
    },
    // 滚动到底部
    scrollToChatBottom() {
      // var currentDistance = this.$refs.detailCont.scrollHeight - this.$refs.detailCont.clientHeight;
      if(this.chatItem.downMessages_id >0 && this.realtimeViewOpen){
        setTimeout(() => {
          this.oldChatHeight = 0;
          this.$refs.detailCont.scrollTop = this.$refs.detailCont.scrollHeight;
          this.$previewRefresh();
        }, 10);
      }else{
        setTimeout(() => {
          if (this.$refs.detailCont) {
            this.$refs.detailCont.scrollTop = this.$refs.detailCont.scrollHeight;
            this.onTheBottom = true;
          }
        }, 10);
      }

    },

    /**
     * Author: brand
     * Creation Time: 2019-02-19 11:40
     * Description: 移除className
     */
    removeClass(el, className) {
      if (!this.hasClass(el, className)) {
        return;
      }
      let newClass = el.className.split(" ");
      newClass.forEach(function(val, index, newClass) {
        if (val === className) {
          newClass.splice(index, 1);
        }
      });
      el.className = newClass.join(" ");
    },
    /**
     * Author: brand
     * Creation Time: 2019-02-19 11:40
     * Description: 添加className
     */
    addClass(el, className) {
      if (this.hasClass(el, className)) {
        return;
      }
      let newClass = el.className.split(" ");
      newClass.push(className);
      el.className = newClass.join(" ");
    },
    /**
     * Author: brand
     * Creation Time: 2019-02-19 11:40
     * Description: 判断是否有className
     */
    hasClass(element, cls) {
      return (" " + element.className + " ").indexOf(" " + cls + " ") > -1;
    },
    /**
     * Author: brand
     * Creation Time: 2019-02-19 11:28
     * Description: 播放音频
     */
    voicePlay(event) {
      let symbolVoice = event.currentTarget.getElementsByClassName(
        "wifi-symbol"
      )[0];
      let audioId = event.currentTarget.getElementsByClassName("audioId")[0];
      let currentAudioIndex = event.currentTarget
        .getElementsByClassName("audioId")[0]
        .getAttribute("index");
      let parentBox = event.currentTarget.parentElement;
      if (this.hasClass(parentBox, "voicing")) {
        this.removeClass(parentBox, "voicing");
        audioId.pause(); // 暂停-从头播放
        audioId.currentTime = 0;
        this.removeClass(symbolVoice, "bofang");
      } else {
        document.querySelectorAll(".bubble").forEach((item, i) => {
          this.removeClass(item, "voicing");
        });
        document.querySelectorAll(".wifi-symbol").forEach((item, i) => {
          this.removeClass(item, "bofang");
        });
        document.querySelectorAll("audio").forEach((audioItem, audioIndex) => {
          audioItem.pause();
          audioItem.currentTime = 0;
        });

        this.addClass(parentBox, "voicing");
        if (this.hasClass(symbolVoice, "bofang")) {
          audioId.pause(); // 暂停-从头播放
          audioId.currentTime = 0;
          this.removeClass(symbolVoice, "bofang");
        } else {
          audioId.play();
          this.addClass(symbolVoice, "bofang");
        }
      }
      // 播放完后执行
      audioId.addEventListener(
        "ended",
        () => {
          this.removeClass(symbolVoice, "bofang");
        },
        false
      );
    },
    /**
     * Author: brand
     * Creation Time: 2019-02-25 14:55
     * Description: 播放视频
     */
    videoPlay(event) {
      let _event = event;

      let videoId = _event.currentTarget.parentElement.parentElement.getElementsByClassName(
        "videoId"
      )[0];
      let parentBox =
        _event.currentTarget.parentElement.parentElement.parentElement;
      // videoId.play()
      if (this.hasClass(parentBox, "playing")) {
        this.removeClass(parentBox, "playing");
        videoId.pause(); // 暂停-从头播放
        videoId.currentTime = 0;
        _event.currentTarget.parentElement.style.display = "block";
      } else {
        document.querySelectorAll(".video_mask").forEach((item, i) => {
          item.style.display = "block";
        });
        document.querySelectorAll(".bubble").forEach((item, i) => {
          this.removeClass(item, "playing");
        });
        document.querySelectorAll("video").forEach((videoItem, videoIndex) => {
          videoItem.pause();
          _event.currentTarget.parentElement.style.display = "block";
          videoItem.currentTime = 0;
        });
        this.addClass(parentBox, "playing");
        _event.currentTarget.parentElement.style.display = "none";
        videoId.play();
      }
      // 播放完后执行
      videoId.addEventListener(
        "ended",
        () => {
          this.removeClass(parentBox, "playing");
          videoId.currentTime = 0;
          document.querySelectorAll(".video_mask").forEach((item, i) => {
            item.style.display = "block";
          });
        },
        false
      );
    },
    // 暂停播放
    videoStop(event) {
      let _event = event;
      let videoId = _event.currentTarget.parentElement.parentElement.getElementsByClassName(
        "videoId"
      )[0];
      let parentBox = _event.currentTarget.parentElement.parentElement;
      this.removeClass(parentBox, "playing");
      // videoId.pause();
      document.querySelectorAll(".video_mask").forEach((item, i) => {
        item.style.display = "block";
      });
      videoId.currentTime = 0;
    },
    /**
     * 获取当前时间
     */
    getTimesCom(time) {
      let date = new Date(new Date().getTime() - time);
      let fillZero = function(str) {
        let s = str.toString();
        if (s.length < 2) s = "0" + s;
        return s;
      };
      return (
        "" +
        date.getFullYear() +
        "-" +
        fillZero(parseInt(date.getMonth() + 1)) +
        "-" +
        fillZero(date.getDate()) +
        " " +
        fillZero(date.getHours()) +
        ":" +
        fillZero(date.getMinutes()) +
        ":" +
        fillZero(date.getSeconds())
      );
    },
    getTimes() {
      let date = new Date();
      let fillZero = function(str) {
        let s = str.toString();
        if (s.length < 2) s = "0" + s;
        return s;
      };
      return (
        "" +
        date.getFullYear() +
        "-" +
        fillZero(parseInt(date.getMonth() + 1)) +
        "-" +
        fillZero(date.getDate()) +
        " " +
        fillZero(date.getHours()) +
        ":" +
        fillZero(date.getMinutes()) +
        ":" +
        fillZero(date.getSeconds())
      );
    },
    /**
     * 【显示表情】
     */
    formatTrendEmoji(val) {
      let s_name = val;
      let s_img = [];
      let rules = /:([^:][a-z_\-]+):/g;
      s_name.replace(rules, function($1, $2) {
        s_img.push($2);
      });
      for (let i = 0; i < s_img.length; i++) {
        let str = "";
        let r_str = ":" + s_img[i] + ":";
        for (let key in emojiData) {
          if (s_img[i] == key) {
            let imgPath = require(`@/libs/emoji/images/${s_img[i]}.gif`);
            str = s_name.replace(
              r_str,
              `<img style="display: inline-block;max-width: 24px;max-height: 24px;" src="` +
                imgPath +
                `" class="img">`
            );
          } else {
            str = s_name.replace(r_str, r_str);
          }
          s_name = str;
        }
      }
      return s_name;
    },
    /**
     * 【获取历史数据】
     */
    chatHistoryClick() {
      if (this.chatItem.historyId > 0) {
        const postData = {
          pageNum: this.chatInit.pageNum,
          visitorId: this.chatItem.onlineVisitorEntity.visitorId,
          messageId: this.chatItem.historyId
        };
        this.chatItem.isChecked = false;
        this.chatItem.isLoading = true;
        setTimeout(() => {
          this.$http.getChatHistory(postData).then(res => {
            const resData = res;
            if (resData.status == 1) {
              this.chatItem.isLoading = false;
              this.chatInit.pageSize = resData.data.length;
              if (this.chatInit.pageSize) {
                let oldHeight = this.$refs.detailCont.scrollHeight;
                this.chatItem.messages = resData.data.concat(
                  this.chatItem.messages
                );
                this.$nextTick(() => {
                  this.oldChatHeight = oldHeight;
                });
              }
            } else {
              Message({
                showClose: true,
                message: resData.msg,
                type: "error",
                duration: 3 * 1000
              });
            }
          });
        }, 500);
      } else {
        this.chatItem.isChecked = false;
        this.chatItem.isLoading = true;
        setTimeout(() => {
          this.chatItem.isLoading = false;
        }, 500);
      }
      this.chatInit.scrollHeight = "calc(100% - 20px)";
    },
    scrollListener() {
      const chatList = document.getElementById("chatContainer");
      if (chatList.scrollTop == 0) {
        if (this.chatInit.pageSize) {
          this.chatInit.pageNum++;
          this.chatHistoryClick();
        }
      }
        let scrollTop = chatList.scrollTop;
        let scrollHeight = chatList.scrollHeight;
        let clientHeight = chatList.clientHeight;
        if (
          scrollHeight - clientHeight - scrollTop < 50
        ) {
          this.scrollLoadTimer = setTimeout(() => {
            if (this.canDownLoadData) {
              this.getNewMsg();
            }
          }, 500);
        }

    },
    /**
       * 向下滚动加载新消息
       * */
      getNewMsg() {
        let item = this.chatItem;
        item.pageNum = item.pageNum?item.pageNum:0
        item.pageNum++;
        if (this.chatItem.downMessages_id > 0) {
          const postData = {
            pageNum: item.pageNum,
            visitorId: item.visitorId,
            messageId: item.downMessages_id,
            order: "1"//0为向前查，1为向后查
          };
          setTimeout(() => {
            this.$http.getChatHistory(postData).then(res => {
              const resData = res;
              if (resData.status == 1) {
                this.chatInit.pageSize = resData.data.length;
                if (this.chatInit.pageSize) {
                  item.messages = item.messages.concat(resData.data);
                  this.oldChatHeight = this.$refs.detailCont.scrollHeight;
                } else {
                  item.pageNum--;
                  this.canDownLoadData = false;
                }
              } else {
                Message({
                  showClose: true,
                  message: resData.msg,
                  type: "error",
                  duration: 3 * 1000
                });
              }
            });
          }, 500);
        } else {}
      },
    /**
     * 【点击展开/关闭右侧】
     */
    sliderShowHandler() {
      this.chatTruth.isSliderShow = !this.chatTruth.isSliderShow;
    },
    /**
     * 【预览图片】
     */
    dialogImgVisibleShow(img) {
      this.chatTruth.dialogImgVisible = !this.chatTruth.dialogImgVisible;
      this.chatTruth.dialogImgVisibleUrl = img;
    },
    /**
     * 点击宝贝链接
     */
    goodsLinkerHandler(url) {
      // shell.openExternal(url)
      window.open(url);
    },
    /**
     * 【小程序访客发送商品】
     */
    goodsWxappHandler() {
      Message({
        showClose: true,
        message: "该链接属于小程序内部链接，只能在微信内部打开",
        type: "warning",
        duration: 3 * 1000
      });
    },
    formatWechatImg(url) {
      let frameid = "frameimg" + Math.random();
      window.img =
        '<img id="img" src=\'' +
        url +
        "?" +
        Math.random() +
        "' style=\"width:calc(100% + 16px);height:100%;margin: -8px 0 0 -8px;\" /><script>window.onload = function() { parent.document.getElementById('" +
        frameid +
        "').height = document.getElementById('img').height+'px'; }<" +
        "/script>";
      return (
        '<iframe id="' +
        frameid +
        '" src="javascript:parent.img;" frameBorder="0" scrolling="no" width="100%" height="100%"></iframe>'
      );
    },
    /**
     * 【点击展开/关闭右侧】
     */
    handleClose() {
      this.chatTruth.isShow = !this.chatTruth.isShow;
      this.$emit("historyShowHandler", this.chatTruth.isShow);
      clearInterval(this.loadDataTimer);
    },
    /**
     * 显示访客头像
     * 截取头像名称中的数字
     */
    avatarX(avatar) {
      let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, "g");
      if (reg.test(avatar)) {
        return avatar;
      } else {
        const img = avatar.substring(avatar.length - 5, avatar.length - 4);
        switch (img) {
          case "y":
            return avatar0;
            break;
          case "1":
            return avatar1;
            break;
          case "2":
            return avatar2;
            break;
          case "3":
            return avatar3;
            break;
          case "4":
            return avatar4;
            break;
          case "5":
            return avatar5;
            break;
          case "6":
            return avatar6;
            break;
          case "7":
            return avatar7;
            break;
          default:
            return avatar;
            break;
        }
      }
    },
    /**
     * 【显示客服头像】
     */
    avatarM(avatar) {
      let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, "g");
      if (reg.test(avatar)) {
        return avatar;
      } else {
        const img = avatar.substring(avatar.length - 5, avatar.length - 4);
        switch (img) {
          case "y":
            return avatar0;
            break;
          case "1":
            return avatar1;
            break;
          case "2":
            return avatar2;
            break;
          case "3":
            return avatar3;
            break;
          case "4":
            return avatar4;
            break;
          case "5":
            return avatar5;
            break;
          case "6":
            return avatar6;
            break;
          case "7":
            return avatar7;
            break;
          default:
            return avatar;
            break;
        }
      }
    },
    /**
     * 【更新数据】
     */
	refreshVisitorInfo(msg){
		this.chatItem.visitorinfo = msg
		this.$emit("refreshVisitorInfo",msg)
	},
    /**
     * 【初始化】
     */
    init() {
      this.chatInit.agentAvatar = this.userData.userInfo.csHeadimg; //【客服头像】
      this.chatInit.agentId = this.userData.userInfo.csId; //【客服id】
      this.chatInit.agentName = this.userData.userInfo.csName; //【客服名称】
      this.chatInit.token = this.userData.token; //【token】
      this.chatItem = this.historyData;
      if (typeof this.chatItem.isChecked == "undefined") {
        this.$set(this.chatItem, "isChecked", false); //【点击加载更多】默认显示
      }
      if (this.chatItem.historyId > 0) {
        this.chatItem.isChecked = true;
      } else {
        this.chatItem.isChecked = false;
      }
      if (typeof this.chatItem.isLoading == "undefined") {
        this.$set(this.chatItem, "isLoading", false); //【是否加载中】默认隐藏
      }
      this.chatInit.scrollHeight = "calc(100% - 58px)";

      this.loadDataTimer = setInterval(() => {
        if (!this.realtimeViewOpen) {
          this.getRealTimeData();
        }
      }, this.loadDataTime);
    },
    /**
     * 实时监听开关
     */
    changeRealtimeView() {
      this.chatInit.pageNum = 1;
      this.getRealTimeData();
      this.realtimeViewOpen = !this.realtimeViewOpen;
    },
    getRealTimeData() {
      const postData = {
        visitorId: this.chatItem.onlineVisitorEntity.visitorId
      };
      this.$http.hisFirstPageVisitorInfoInfo(postData).then(res => {
        const resData = res;
        if (resData.status == 1) {
          this.chatItem = resData.data.visitorData;
          if (typeof this.chatItem.isChecked == "undefined") {
            this.$set(this.chatItem, "isChecked", false); //【点击加载更多】默认显示
          }
          if (this.chatItem.historyId > 0) {
            this.chatItem.isChecked = true;
          } else {
            this.chatItem.isChecked = false;
          }
          if (typeof this.chatItem.isLoading == "undefined") {
            this.$set(this.chatItem, "isLoading", false); //【是否加载中】默认隐藏
          }
          // this.chatItem.isChecked = true
          this.chatItem.isLoading = false;
          this.$nextTick(() => {
            this.scrollToChatBottom();
          });
        }
      });
    },
    /**
     * 【发送图片】
     */
    sendImgDataHandler(type, data) {
      const tmp_data = {
        type: "say",
        sendtime: this.getTimes(),
        msg_id:
          this.chatInit.agentId +
          this.chatItem.onlineVisitorEntity.visitorId +
          new Date().getTime(),
        agent_avatar: this.chatInit.agentAvatar,
        sendname: this.chatInit.agentName,
        agent_nickname: this.chatInit.agentName,
        from_uid: this.chatInit.agentId,
        to_uid: this.chatItem.onlineVisitorEntity.visitorId,
        role: "agent",
        msg_type: type,
        text: data
      };
      const postData = {
        messagesId: this.chatItem.messageId,
        visitorId: this.chatItem.onlineVisitorEntity.visitorId,
        msgType: type,
        talk_time: "0",
        callingNo: this.chatItem.callingNo,
        text: data
      };
      this.$http.getReplyHandler(postData).then(res => {
        const resData = res;
        if (resData.status == 1) {
          this.newMsgId = res.callingId;
          tmp_data.callingId = res.callingId;
          this.sendTalkData(tmp_data);
          document.getElementById("chatTextArea").focus();
          this.chatInit.textarea = "";
          this.chatTruth.sendBtn = true;
        }
      });
    },
    /**
     * 发送图片
     */
    btnUploadImgHandler() {
      this.$refs.uploadImgIpt.click();
    },
    ImgSendClickHandler(e) {
      let img = e.target.files[0];
      let type = img.type;
      let size = img.size;
      if (this.imgAccept.indexOf(type) == -1) {
        this.$message({
          showClose: true,
          message:
            "图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      if (size > 5242880) {
        Message({
          showClose: true,
          message: "请选择5M以内的图片！",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let formdata = new FormData();
      formdata.set("file", img);
      this.$http
        .uploadImageAPI(formdata)
        .then(res => {
          console.log("img=", res);
          if (res.status == 1) {
            this.sendImgDataHandler("image", res.data);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "图片发送失败，请重试！",
            type: "error",
            duration: 3 * 1000
          });
        });
    },
    /**
     * 发送文件
     */
    btnUploadFileHandler() {
      this.$refs.uploadFileIpt.click();
    },
    FileSendClickHandler(e) {
      let img = e.target.files[0];
      let type = img.type;
      let size = img.size;
      if (this.fileAccept.indexOf(type) == -1) {
        this.$message({
          showClose: true,
          message:
            "文件格式不正确，请选择我们支持的文件格式 .txt, .rar, .zip, .doc, .xls, .cvs",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      if (size > 1024 * 1024 * 10) {
        Message({
          showClose: true,
          message: "请选择10M以内的文件！",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let formdata = new FormData();
      formdata.set("file", img);
      this.$http
        .uploadFileAPI(formdata)
        .then(res => {
          if (res.status == 1) {
            let fileStr = res.data.fileName + "," + res.data.fileUrl;
            this.sendImgDataHandler("file", fileStr);
          } else {
            Message({
              showClose: true,
              message: "文件发送失败，请重试！",
              type: "error",
              duration: 3 * 1000
            });
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "文件发送失败，请重试！",
            type: "error",
            duration: 3 * 1000
          });
        });
    },
    /**
     * 发送视频文件
     */
    btnUploadVideoHandler() {
      this.$refs.uploadVideoIpt.click();
    },
    videoSendClickHandler(e) {
      let img = e.target.files[0];
      let type = img.type;
      let size = img.size;
      console.log(img);
      if (this.videoAccept.indexOf(type) == -1) {
        this.$message({
          showClose: true,
          message: "请选择MP4格式的视频",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      // if (size > 5242880) {
      //     Message({
      //         showClose: true,
      //         message: '请选择5M以内的文件！',
      //         type: 'error',
      //         duration: 3 * 1000
      //     })
      //     return false
      // }
      let formdata = new FormData();
      formdata.set("file", img);
      this.$http
        .uploadVideoAPI(formdata)
        .then(res => {
          if (res.status == 1) {
            console.log("file=", res);
            let fileStr = res.data.fileName + "," + res.data.fileUrl;
            this.sendVideoDataHandler("video", fileStr);
          } else {
            Message({
              showClose: true,
              message: res.message,
              type: "error",
              duration: 3 * 1000
            });
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "文件发送失败，请重试！",
            type: "error",
            duration: 3 * 1000
          });
        });
    },
    sendVideoDataHandler(type, data) {
      let video_message = {
        type: "say",
        sendtime: this.getTimes(),
        from_uid: this.chatInit.agentId,
        to_uid: this.chatItem.onlineVisitorEntity.visitorId,
        agent_nickname: this.chatInit.agentName,
        role: "agent",
        msg_type: type,
        text: data.videoUrl,
        reduced_graph: data.reducedImage,
        talk_time: data.time
      };
      const postData = {
        messagesId: this.chatItem.messageId,
        visitorId: this.chatItem.onlineVisitorEntity.visitorId,
        msgType: type,
        talk_time: "0",
        callingNo: this.chatItem.callingNo,
        text: data.videoUrl
      };
      this.$http.getReplyHandler(postData).then(res => {
        const resData = res;
        if (resData.status == 1) {
          this.newMsgId = res.callingId;
          video_message.callingId = res.callingId;
          this.sendTalkData(video_message);
          document.getElementById("chatTextArea").focus();
          this.chatInit.textarea = "";
          this.chatTruth.sendBtn = true;
        }
      });
    },
    /**
     * 快捷回复
     */
    quickReceiveClickHandler() {},
	/**
	 * 【标签信息】
	 */
	tagsHandler(msg) {
	  this.chatItem.tags = msg;
	  this.chatItem.tags.forEach(item => {
	    item.onlineVisitorTagEntity = {}
	    item.onlineVisitorTagEntity.tagName = item.text
	    item.onlineVisitorTagEntity.tagId = item.id
	    item.tagColor = item.colorName
	  })
  },
  searchResultItemed(){
    this.ticketData.pageSize = this.chatItem.messages.length;
    document.getElementsByClassName("history-track-container").scrollTop = 0;
    this.ticketData.initData[0] = this.historyData
    this.ticketData.initData.map((item, index) => {
      if (this.chatItem.visitorId == item.visitorId) {
        this.ticketData.initData.splice(index, 1);
      }
    });
    if (this.chatItem.historyId > 0) {
      this.chatItem.isChecked = true;
    } else {
      this.chatItem.isChecked = false;
    }
    this.onlineClickHandler(this.chatItem)
  },
  /**
     * 【选择对话中的访客】
     * 存储当前选中访客id，同时在对话列表中给选中的访客添加选中样式
     * 把选中访客数据赋值给变量messages
     */
    onlineClickHandler(item) {
      // this.quickReplyKeyword = ''
      // this.quickReplySearchList = []
      document.querySelectorAll("div").forEach((item, i) => {
        this.hasClass(item, "playing") ? this.removeClass(item, "playing") : "";
        this.hasClass(item, "voicing") ? this.removeClass(item, "voicing") : "";
      });

      // this.online.visitorId = item.visitorId;
      item.isDot = false;
      item.badge = true;
      item.unreadNum = 0;
      Store.save("currentId", item.visitorId);
      console.log("item==", item);

        this.ticketData.initData.forEach((data, i) => {
          if (data.visitorId == item.visitorId) {
            data.unreadNum = 0;
            this.chatItem = data;
            this.$nextTick(() => {
              let draftData = Store.fetch(item.visitorId);
              if (draftData.length > 0) {
                this.chatTruth.sendBtn = false;
                this.chatInit.textarea = draftData;
                document.getElementById("chatTextDiv").innerHTML = draftData;
              } else {
                this.chatInit.textarea = "";
                document.getElementById("chatTextDiv").innerHTML = "";
              }
            });
            eventBus.$emit("stopVoice");
            // if (item && item.visitorId) {
            //   this.getAccessTrack(item.visitorId);
            // }
          }

        });
         setTimeout(() => {
            this.fromSearch = false;
            this.$refs.detailCont.scrollTop = 0;
            this.addClass(
              this.$refs.detailCont.firstElementChild,
              "bgColorChangeCss"
            );
          }, 300);
          this.$nextTick(() => {
            this.scrollToChatBottom();
            // 解决动态绑定audio/video src还是播放上一个地址bug
            // this.$refs.audio ? this.$refs.audio.load() : "";
            // this.$refs.video ? this.$refs.video.load() : "";
          });
    },
  },
  created() {
	Cookies.get('externalLinkList') ? this.externalLinkList = JSON.parse(Cookies.get('externalLinkList')) : ''
    this.init();
    if(this.chatItem.downMessages_id >= 0){
      this.searchResultItemed()
    }
  },
  mounted() {
    let _this = this;
    eventBus.$on("clearHistoryTimer", () => {
      clearInterval(this.loadDataTimer);
      this.realtimeViewOpen = false;
      this.loadDataTimer = null;
    });
    document.addEventListener("click", function(e) {
      _this.chatTruth.showEmoji = false;
    });
    if(this.chatItem.downMessages_id >= 0){
      this.showPop = false
    }
  },
  beforeDestroy() {
    clearInterval(this.loadDataTimer);
  }
};
</script>

<style lang="scss">
//播放按钮
// video::-webkit-media-controls-play-button {
//   display: none;
// }
//进度条
video::-webkit-media-controls-timeline {
    display: none;
}
//观看的当前时间
video::-webkit-media-controls-current-time-display{
    display: none;
}
//剩余时间
video::-webkit-media-controls-time-remaining-display {
    display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
    display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
    display: none;
}
.bgColorChangeCss {
  animation: bgColorChange 3s;
  -moz-animation: bgColorChange 3s;
  /* Firefox */
  -webkit-animation: bgColorChange 3s;
  /* Safari 和 Chrome */
  -o-animation: bgColorChange 3s;
  /* Opera */
}
@keyframes bgColorChange {
    from {
      background: rgba(8, 201, 255, 0.17);
    }

    to {
      background: #dddfe0;
    }
  }

  @-moz-keyframes bgColorChange

  /* Firefox */
    {
    from {
      background: rgba(8, 201, 255, 0.17);
    }

    to {
      background: #dddfe0;
    }
  }

  @-webkit-keyframes bgColorChange

  /* Safari 和 Chrome */
    {
    from {
      background: rgba(8, 201, 255, 0.17);
    }

    to {
      background: #dddfe0;
    }
  }

  @-o-keyframes bgColorChange

  /* Opera */
    {
    from {
      background: rgba(8, 201, 255, 0.17);
    }

    to {
      background: #dddfe0;
    }
  }
.chat-pannel {
  display: flex;
  background: #fff;
  height: 100%;

  .pannel-left {
    // width: 100%;
    width: 70%;
    max-width: calc(100% - 250px);
    height: 100%;
    background: #f5f6f7;
    border-right: 1px solid #e5e5e5;

    transition: width 0.1s linear;

    .quick-left-chat {
      width: 100%;
      height: 100%;
      transition: width 0.1s linear;

      .pannel-left-header {
        height: 60px;
        border-bottom: 1px solid #e5e5e5;

        .pannel-title {
          height: 40px;
          padding: 10px 20px;

          .visitor {
            display: flex;
            align-items: center;
            .historyTrack{
              font-size: 12px;
              cursor: pointer;
              color: $mainColor;
            }
            .realTime-view-open {
              margin-left: auto;
              cursor: pointer;
              color: $mainColor;
              font-size: 12px;
            }

            &-img {
              span {
                display: block;
                width: 40px;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                color: #fff;
                background: #3296fa;
                border-radius: 100%;
                text-align: center;

                img {
                  display: block;
                  width: 100%;
				  border-radius: 50%;
                }

                .off {
                  filter: grayscale(100%);
                  -webkit-filter: grayscale(100%);
                }
              }
            }

            &-info {
              margin-left: 10px;
              width: 68%;
              .nick {
                height: 20px;
                line-height: 20px;
                overflow: hidden;

                span {
                  font-size: 14px;
                  color: #010101;
                  margin-right: 10px;
                  max-width: 160px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }

                button {
                  padding: 0;

                  span {
                    font-size: 12px;
                    color: #808080;

                    .svg-icon {
                      margin-bottom: 3px;
                    }
                  }
                }

                .el-input {
                  width: 43%;
                  font-size: 12px;

                  &__inner {
                    height: 20px;
                    line-height: 20px;
                    padding: 0 5px;
                    border-radius: 0;
                  }
                }
              }

              .tags {
                height: 20px;

                .client-status {
                  margin-right: 5px;
                  line-height: 20px;
                }

                .tag {
                  margin-top: 1px;
                  padding: 0 5px;
                  height: 18px;
                  line-height: 16px;
                  max-width: 60px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }

          .status {
            line-height: 40px;

            .el-button {
              font-size: 12px;

              .svg-icon {
                margin-bottom: 2px;
              }

              &:last-child {
                margin-left: 5px;
              }
            }
          }
        }
      }

      .pannel-left-cont {
        height: calc(100% - 60px);

        .off {
          filter: grayscale(100%);
          -webkit-filter: grayscale(100%);
        }

        .pannel-message {
          width: 100%;
          height: calc(100% - 183px);
          position: relative;

          .load-more {
            background-color: #f0f9eb;
            color: #67c23a;
            text-align: center;
            position: absolute;
            z-index: 99;
            top: 0;
            left: 0;
            right: 0;

            .el-button {
              font-size: 12px;
              line-height: 36px;
              color: #67c23a;
              padding: 0;
            }
          }

          .messages {
            width: 100%;
            padding: 10px 20px;
            overflow-y: scroll;
            height: 100%;

            .client-event {
              text-align: center;
              color: #808080;
              margin: 10px;

              .msg-date {
                margin-bottom: 5px;
                color: #808080;
                text-align: center;
              }
            }

            .msg-agent,
            .msg-client {
              position: relative;

              .j-user {
                display: table-cell;
                width: 36px;
                height: 36px;

                .agent-name {
                  display: inline-block;
                  width: 36px;
                  height: 36px;
                  line-height: 36px;
                  font-size: 14px;
                  color: #fff;
                  text-align: center;
                  border-radius: 100%;
                  overflow: hidden;

                  img {
                    display: block;
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .time-sender {
                line-height: 26px;
                font-size: 12px;
                color: #808080;
                clear: both;
              }

              .bubble {
                position: relative;

                img {
                  max-width: 100%;
                }

                .text {
                  border-radius: 2px;
                  padding: 5px 10px;
                  font-size: 14px;
                  line-height: 26px;
                  word-wrap: break-word;
                  word-break: break-all;

                  .img {
                    width: 24px;
                  }

                  .text-emoji {
                    margin: 0 2px;
                    width: 24px;
                    height: auto;
                    display: inline-block;
                    vertical-align: -5px;
                  }

                  a {
                    color: $mainColor;
                  }
                }

                .el-dialog {
                  .el-dialog__body {
                    padding: 20px;

                    img {
                      width: 100%;
                    }
                  }
                }

                .upload-img {
                  max-width: 250px;
                  height: auto;
                }

                .upload-img-failed {
                  width: 70px;
                }

                .upload-img-failed-txt {
                  padding-top: 3px;
                  font-size: 12px;
                  color: #999;
                  text-align: center;
                }

                .upload-file {
                  color: #a2a9b2;
                  padding: 10px;

                  .fa {
                    font-size: 26px !important;
                  }

                  .file-name {
                    padding: 0 5px;
                  }

                  .file-download {
                    color: $mainColor;
                  }
                }

                .foresee {
                  .text {
                    display: inline-block;
                  }

                  p {
                    display: inline-block;
                    font-size: 12px;
                    color: #9b9b9b;
                  }
                }
              }
            }

            .msg-agent {
              padding: 20px 50px 20px 30%;

              .j-user {
                float: right;
                margin: 0 -50px 0 10px;

                .agent-name {
                  background: #3296fa;
                  background: #fff;
                }
              }

              .time-sender {
                text-align: right;
              }

              .bubble {
                float: right;

                .text {
                  background-color: #cce6ff;
                  border: 1px solid #bed6ee;
                }

                // &:after{
                //     position: absolute;
                //     top: 15px;
                //     right: -6px;
                //     content: "";
                //     width: 0;
                //     height: 0;
                //     border-top: 5px solid transparent;
                //     border-bottom: 5px solid transparent;
                //     border-left: 6px solid #ebebeb;
                // }
              }
            }

            .msg-client {
              padding: 20px 30% 20px 50px;

              .j-user {
                float: left;
                margin: 0 10px 0 -50px;

                .agent-name {
                  background: #ff7376;
                }
              }

              .time-sender {
                text-align: left;
              }

              .bubble {
                float: left;

                .text {
                  background-color: #fff;
                  border: 1px solid #ededee;
                }

                // &:before{
                //     position: absolute;
                //     top: 15px;
                //     left: -6px;
                //     content: "";
                //     width: 0;
                //     height: 0;
                //     border-top: 5px solid transparent;
                //     border-bottom: 5px solid transparent;
                //     border-right: 6px solid #dcedfa;
                // }
              }

              &.msg-client-inputing {
                .bubble {
                  background: #fff;
                  border: 1px solid #eee;

                  .text,
                  .inputing-img,
                  .inputing-text {
                  }

                  .inputing-img {
                    margin: 0 5px;
                    width: 44px;
                    height: 4px;
                    background: url(/Public/images/mp_chat_inputing.gif) center
                      no-repeat;
                  }

                  .inputing-text {
                    color: #b8bcc4;
                  }
                }
              }
            }

            .goodsLink {
              padding: 10px;
              font-size: 14px;
              line-height: 26px;
              background: #fff;
              width: 290px;
              border-radius: 2px;
              border: 1px solid #e5e5e5;
              word-wrap: break-word;
              word-break: break-all;

              &:hover {
                cursor: pointer;
              }
              .title {
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                padding-bottom: 5px;
                overflow: hidden;
                p {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .fl {
                  width: inherit;
                  float: left;
                }
                .fr {
                  width: inherit;
                  text-align: right;
                }
                .red {
                  color: #f00;
                }
              }
              .goodsMain {
                /*width: calc(100% - 90px);*/
                height: 80px;
                padding-left: 90px;
                .goodsLef {
                  float: left;
                  width: 80px;
                  height: 80px;
                  margin-left: -90px;
                  .wxapp-img {
                    width: 100%;
                    height: 100%;
                    border: 1px solid #ececec;
                    box-sizing: border-box;
                  }
                  span {
                    display: block;
                    width: 100%;
                    height: 100%;
                    border: 1px solid #ececec;
                    box-sizing: border-box;
                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
                .goodsRig {
                  width: 100%;
                  height: 80px;
                  h3 {
                    color: #606266;
                    font-size: 12px;
                    height: 36px;
                    max-height: 36px;
                    line-height: 18px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                  }
                  p {
                    margin-top: 20px;
                    font-size: 12px;
                    line-height: 24px;
                    color: #ff2f2f;
                    em {
                      font-family: Arial;
                      font-style: normal;
                    }
                  }
                  &.coupon {
                    h3 {
                      color: #606266;
                      font-size: 12px;
                      height: 20px;
                      max-height: 20px;
                      line-height: 20px;
                      white-space: nowrap;
                    }
                    p {
                      margin-top: 5px;
                      line-height: 20px;
                      color: inherit;
                      &.time {
                        line-height: 14px;
                      }
                      .red {
                        color: #ff2f2f;
                      }
                    }
                  }
                }
              }
            }

            .deliveryMsg,
            .refundMsg,
            .arrivalMsg,
            .placeOrderMsg {
              width: 300px;
              background-color: #fff;
              padding: 8px 14px;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              .orderTitle {
                font-size: 13px;
                font-weight: bold;
                color: #333;
              }
              .orderGood-container {
                display: flex;
                margin: 8px 0;
                background-color: #fafafa;
                border-radius: 3px;
                overflow: hidden;
                cursor: pointer;
                .goods-image {
                  width: 40px;
                  height: 40px;
                  img {
                    width: 100%;
                    height: 100%;
                    max-width: 100% !important;
                  }
                }
                .goods-detail {
                  flex: 1;
                  overflow: hidden;
                  padding: 0 6px;
                  box-sizing: border-box;
                  .goods-order-title {
                    font-size: 13px;
                    color: #333;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height: 25px;
                  }
                  .goods-order-detail {
                    font-size: 10px;
                    color: #666;
                  }
                }
              }

              .operation-btn {
                text-align: right;
                padding-top: 8px;
                a {
                  background-color: #3396fb;
                  color: #fff !important;
                  font-size: 13px;
                  padding: 6px 10px;
                  border-radius: 6px;
                  cursor: pointer;
                  display: inline-block;
                }
              }
            }
            .deliveryMsg {
              .van-icon-arrow-down {
                cursor: pointer;
              }
              .deliveryInfo {
                font-size: 12px;
                line-height: 22px;
                .deliveryInfo-item {
                  display: flex;
                  .deliveryInfo-label {
                    width: 60px;
                  }
                  .deliveryInfo-detail {
                    flex: 1;
                  }
                }
              }
            }
            .placeOrderMsg {
              .addressInfo {
                display: flex;
                font-size: 12px;
                .label {
                  width: 40px;
                }
                .detail {
                  flex: 1;
                }
              }
            }
            .refundMsg{
                .order-msg-no{
                    padding-top: 6px;
                }
                .refundInfo{
                    font-size: 13px;
                    color: #333;
                }
            }
          }
        }

        .pannel-black {
          width: 100%;
          height: 180px;
          margin-top: 3px;
          text-align: center;
          background: #fff;
          border-top: 1px solid #e5e5e5;

          p {
            font-size: 18px;
            padding: 55px 0 0;
          }
        }

        .pannel-edit {
          width: 100%;
          height: 180px;
          margin-top: 3px;
          position: relative;

          .chat-bar-icon {
            width: 24px;
            height: 24px;
          }

          &.editFocus {
            background: #fff;
          }

          .edit-header {
            line-height: 24px;
            padding: 5px 10px 0;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #eee;

            .chat-bar-container {
              display: flex;
              padding: 0 0 5px;

              .quick-reply {
                margin-left: auto;
                font-size: 14px;
              }

              .item {
                color: #a8adaf;
              }

              .item:hover {
                color: #a8adaf;
              }
            }

            .emoji-wrap {
              position: absolute;
              left: -50px;
              width: 380px;
              height: 114px;
              bottom: 30px;
              background: #fff;
              z-index: 10;
              padding: 10px;
              border: 1px solid #e5e5e5;
              box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

              li {
                float: left;
                padding: 3px;
                cursor: pointer;
              }
            }

            .sendImg {
              display: inline-block;
            }

            .sendImgItem {
              .el-upload-list {
                display: none;
              }
            }

            button {
              font-size: 22px;
              color: #a8adaf;
              margin: 0 5px;
              padding: 0;
              background: none;
              border: none;

              .svg-icon {
                margin-bottom: 2px;
              }

              &:hover {
                color: $mainColor;
                opacity: 0.7;
              }

              &.el-button--text {
                font-size: 14px;
                line-height: 24px;
                color: #bfc0c1;
                cursor: pointer;

                &:hover {
                  color: $mainColor;
                  opacity: 0.7;
                }
              }
            }
          }

          .edit-middle {
            height: calc(100% - 96px);

            .el-textarea {
              textarea {
                height: 100%;
                background: none;
                border: none;
                resize: none;
              }
            }
          }

          .edit-footer {
            height: 36px;
            padding: 15px 20px;
            text-align: right;

            button {
              &.el-button--text {
                font-size: 12px;
                color: #bfc0c1;
                cursor: default;
              }
            }
          }
        }
      }
    }

    .quick-right-chat {
      width: 0;
      height: 100%;
      background: #fff;
      border-left: 1px solid #e5e5e5;
      transition: width 0.1s linear;
    }

    &.isQuickShow {
      .quick-left-chat {
        width: calc(100% - 220px);
      }

      .quick-right-chat {
        width: 220px;

        .b-title {
          height: 20px;
          line-height: 20px;
          padding: 20px 20px 19px;
          border-bottom: 1px solid #e5e5e5;

          h3 {
            font-size: 14px;
          }

          span {
            display: inline-block;
            height: 20px;
            cursor: pointer;
          }
        }
      }
    }

    .btn-open {
      position: absolute;
      top: 50%;
      right: -25px;
      z-index: 1;
      width: 25px;
      height: 66px;
      margin-top: -33px;
      /*background-image: url("~@/assets/images/btn-slider.png");*/
      background-repeat: no-repeat;
      background-position: 0 0;
      cursor: pointer;
    }
  }

  .pannel-right {
    width: 30%;
    min-width: 250px;
    height: 100%;
    background: #fff;
    transition: width 0.1s linear;

    .chat-user-tab {
      height: 100%;
      // height: calc(100% - 60px);
      // margin-top: 60px;
      overflow-y: scroll;
      overflow-x: hidden;

      .el-tabs {
        .el-tabs__header {
          // position: absolute;
          // top: 0;
          // left: 0;
          width: 100%;
          height: 60px;
          margin-bottom: 0;
          overflow: hidden;

          .el-tabs__nav-wrap {
            // margin-top: 10px;
            &::after {
              height: 0;
              border-bottom: none;
            }

            .el-tabs__nav {
              width: 100%;
              display: flex;

              .el-tabs__item {
                flex: 1;
                padding: 0;
                text-align: center;
              }
            }
          }
        }

        .el-tabs__content {
          padding: 10px 10px 0 40px;

          .tab-noData {
            padding: 30px 10px 40px 20px;
            border-bottom: 1px solid #e5e5e5;

            p {
              text-align: center;
            }
          }
        }
      }

      .tab-components {
        padding: 0 10px 0 30px;
      }
    }
  }

  &.openInfo {
    .pannel-left {
      width: 100%;
      max-width: 100%;
      // width: calc(100% - 25px);
      // max-width: calc(100% - 25px);
      .btn-open {
        right: 0;
        background-position: 0 -66px;
      }
    }

    .pannel-right {
      display: none;
    }
  }

  .history-track-dialog {
    .history-track-container {
      height: 400px;
      overflow-y: scroll;

      .history-track-item + .history-track-item {
        border-top: 1px dashed #eee;
      }

      .history-track-item {
        display: flex;
        padding: 10px 0;

        .history-track-time {
          text-align: center;
          font-size: 13px;
          width: 100px;
        }

        .history-track-content {
          flex: 1;
          font-size: 13px;

          a {
            color: #3296fa;
            cursor: pointer;
          }
        }
      }
    }
  }

}

.btn-close {
  position: absolute;
  display: inline-block;
  height: 36px;
  width: 18px;
  line-height: 32px;
  z-index: 1;
  border-radius: 18px 0 0 18px;
  box-sizing: border-box;
  text-align: right;
  color: #bbb;
  border-top: 1px solid #cccccd;
  border-bottom: 1px solid #cccccd;
  border-left: 1px solid #cccccd;
  margin-left: -18px;
  margin-top: 6px;
  background: #f5f6f7;
  cursor: pointer;

  .svg-icon {
    margin-left: 7px;
  }
}

.dialogCheckImg {
  .el-dialog__body {
    max-height: 520px;
    text-align: center;
    overflow-y: scroll;
  }
}

.video_css {
  width: 280px;
  height: 420px;
  position: relative;
  overflow: hidden;

  video {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video_mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.6);

    .video_play_icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      color: #fff;
      width: 35px;
      height: 35px;
      cursor: pointer;
    }
  }
}

.voice {
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  .play_voice {
    width: 100%;
    line-height: 30px;
  }

  .wifi-symbol {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    overflow: hidden;

    &.voice-agent {
      float: right;
      transform: rotate(180deg) scale(0.6);
    }

    &.voice-client {
      float: left;
      transform: rotate(0deg) scale(0.6);
    }

    &.bofang {
      .second {
        animation: bofang 1.3s infinite 0.2s;
      }

      .third {
        animation: bofang 1.3s infinite 0.35s;
      }
    }
  }

  .wifi-circle {
    /*border: 3px solid #000;*/
    /*border-radius: 50%;*/
    width: 30px;
    height: 30px;
    position: absolute;
  }

  .first {
    background: url("~@/assets/images/1.png") no-repeat center center;
    /*width: 3px;*/
    /*height: 3px;*/
    /*background: #000;*/
    /*top: 25px;*/
    /*left: 25px;*/
  }

  .second {
    background: url("~@/assets/images/2.png") no-repeat center center;
    /*width: 25px;*/
    /*height: 25px;*/
    /*top: 15px;*/
    /*left: 15px;*/
    /*&.bofang{*/
    /*animation: bofang 1.3s infinite 0.2s;*/
    /*}*/
  }

  .third {
    background: url("~@/assets/images/3.png") no-repeat center center;
    /*width: 40px;*/
    /*height: 40px;*/
    /*top: 5px;*/
    /*left: 5px;*/
    /*&.bofang{*/
    /*animation: bofang 1.3s infinite 0.35s;*/
    /*}*/
  }

  @include keyframes(bofang) {
    0% {
      opacity: 0; /*初始状态 透明度为0*/
    }
    100% {
      opacity: 1; /*结尾状态 透明度为1*/
    }
  }
}
</style>
